// Cliente HTTP del PANEL DE PLATAFORMA.
//
// Es un archivo aparte, y no una opción de `src/api.js`, a propósito. Los
// dos clientes guardan su token bajo claves distintas y ninguno sabe leer
// la del otro: así, un token de plataforma no puede acabar adjunto a una
// petición de cliente por un `if` mal puesto seis meses después.
//
// El backend ya rechaza la mezcla —cada token lleva su audiencia— pero esa
// es la segunda barrera. Esta es la primera, y es la que evita que el
// error se cometa siquiera.

const CLAVE_TOKEN = 'tego_panel_token';

export function guardarTokenPanel(token) {
  if (token) sessionStorage.setItem(CLAVE_TOKEN, token);
  else sessionStorage.removeItem(CLAVE_TOKEN);
}

// `sessionStorage` y no `localStorage`: la sesión del panel muere al
// cerrar la pestaña. Es la credencial que alcanza a todos los clientes a
// la vez; dejarla viva en una máquina compartida sería regalarla.
export function leerTokenPanel() {
  return sessionStorage.getItem(CLAVE_TOKEN);
}

export class ErrorApi extends Error {
  constructor(mensaje, status) {
    super(mensaje);
    this.status = status;
  }
}

async function procesar(respuesta) {
  const esJson = (respuesta.headers.get('content-type') || '').includes('application/json');
  const cuerpo = esJson ? await respuesta.json() : null;

  if (!respuesta.ok) {
    const detalle =
      (cuerpo && (cuerpo.detalle || cuerpo.detail)) || `Error ${respuesta.status}`;
    throw new ErrorApi(
      typeof detalle === 'string' ? detalle : 'Solicitud inválida.',
      respuesta.status,
    );
  }
  return cuerpo;
}

function cabeceras(extra = {}) {
  const h = { ...extra };
  const token = leerTokenPanel();
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

export const apiPanel = {
  get: (ruta) => fetch(`/api/panel${ruta}`, { headers: cabeceras() }).then(procesar),

  post: (ruta, datos) =>
    fetch(`/api/panel${ruta}`, {
      method: 'POST',
      headers: cabeceras({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(datos ?? {}),
    }).then(procesar),

  // ¿Está habilitado el panel en esta instalación? Se consulta sin token,
  // antes de pintar el formulario: una instalación de un solo cliente debe
  // decirlo con palabras, no con un 503 en la consola del navegador.
  salud: () => fetch('/api/panel/salud').then(procesar),
};
